import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import ecIcon from '../assets/icons/ecIcon.svg';
import { formatDate } from '../utils/index';

export const ElevationCertificateInfo = ({
  bfe,
  ffe,
  deltaFb,
  modifiedDate,
  scrollToElevation,
}) => {
  return (
    <div className="relative w-full border-2 bg-[#f7f1c8] p-4">
      <div className="mr-6 flex items-center gap-4">
        <ExclamationTriangleIcon className="w-8 stroke-2 text-sunshine" />
        <h4 className="font-bold">This property has an elevation certificate</h4>
      </div>
      <p>
        Based on information on the elevation certificate, the base flood elevation is {bfe} feet
        and the structure is elevated to {ffe} feet.{' '}
        <b>The residence is {deltaFb} feet above base flood elevation.</b>{' '}
        {deltaFb > 0 && 'The structure on this property has reduced risk. '}
      </p>
      <button style={{ fontSize: '1em', textDecoration: 'underline' }} onClick={scrollToElevation}>
        <b> Click to learn more </b>
      </button>
      <p>Last updated: {formatDate(modifiedDate)}</p>
      <div className="absolute right-2 top-2">
        <img alt="Elevation certificate icon" className="w-8" src={ecIcon} />
      </div>
    </div>
  );
};
